import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { Heading } from '../../components';

import css from './ListingPage.module.css';

/**
 * Nextmine: sælgerens korte video af stykket.
 *
 * Vises kun når der ér en - de fleste annoncer har kun fotos, og et tomt
 * "Video"-afsnit ville ligne en mangel. Selve filen ligger hos videovaerten;
 * annoncen kender kun afspilnings-adressen.
 *
 * @param {Object} props
 * @param {Object} props.video { uid, iframeUrl, thumbnailUrl }
 */
const SectionVideoMaybe = props => {
  const { video } = props;
  const iframeUrl = video?.iframeUrl;

  if (!iframeUrl) {
    return null;
  }

  return (
    <section className={css.sectionVideo}>
      <Heading as="h2" rootClassName={css.sectionHeadingWithExtraMargin}>
        <FormattedMessage id="ListingPage.videoTitle" />
      </Heading>
      <div className={css.videoFrame}>
        <iframe
          className={css.videoPlayer}
          src={iframeUrl}
          title="Video"
          loading="lazy"
          allow="accelerometer; gyroscope; encrypted-media; picture-in-picture;"
          allowFullScreen
        />
      </div>
    </section>
  );
};

export default SectionVideoMaybe;
